import slice from './reducer';

const { actions, reducer } = slice;

export const commonActions = actions;

export default reducer;
